import React from 'react'
import { Box } from 'reactjs-admin-lte'
import { Image, FormControl, Grid, Row, Col, Button } from 'react-bootstrap'
// import QRstore from './QRstore'
import QRstore from '../../../stores/QRstore'
import querystring from 'querystring'
import moment from 'moment'
import { QRCode } from 'react-qr-svg'
import FontAwesome from 'react-fontawesome'

/* 
      Example of workData from backend

      workData:{
        "ext_work_no": "17221edb-ffe7-11e7-b",
        "work_no": "SR304..590\/2559",
        "car_registration_no": "\u0e01\u0e15-6703",
        "owner_name": "\u0e19\u0e23\u0e34\u0e19",
        "car_detail": {
            "car_registration_no": "\u0e01\u0e15-6703",
            "car_type": "PICKUP",
            "model_id": "214",
          },
        "work_state": [ .... ],
        "task":{
            "bf_task_id": "65",
            "tasklist": [
                {
                    "taskName": "\u0e23\u0e37\u0e49\u0e2d",
                    "taskValue": "dismanlingState",
                    "taskStatus": "0",
                    "startDate": "15\/01\/2018",
                    "startTime": "",
                    "endDate": "19\/01\/2018",
                    "endTime": "",
                    "duration": 4
                }
            ],
            "total_cost": "0",
            "remark": "",
            "work_no": "SR304..590\/2559",
          }
      }

    */

class Tracker extends React.Component {
  constructor(props) {
    super(props)
    this.EMPLOYEE_URL = 'http://localhost:3000/?p=tr&e_id=b570781953&o_id=korat'
    this.TASK_STATES = {
      NONE: 'NONE',
      STARTED: 'STARTED',
      DISPLAY_SCAN_TO_PAUSE: 'DISPLAY_SCAN_TO_PAUSE',
      PAUSE: 'PAUSE',
      END: 'END'
    }

    this.QR_BG_COLOR = {
      DEFAULT: '#FFFFFF',
      PAUSE: 'yellow',
      STOP: 'green',
      SCANNING: 'orange'
    }
    this.state = {
      currentTaskState: this.TASK_STATES.NONE,
      employeeUrl: this.EMPLOYEE_URL,
      workUrl: '',
      profileImgURL: '',
      employeeData: {},
      workData: {},
      startTime: null,
      elapsed: {
        hours: 0,
        minutes: 0,
        seconds: 0
      },
      errMsg: '',
      qrPauseBgColor: this.QR_BG_COLOR.DEFAULT,
      qrStopBgColor: this.QR_BG_COLOR.DEFAULT
    }
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  startTimer() {
    clearInterval(this.timer)
    this.timer = setInterval(this.tick.bind(this), 1000)
  }

  tick() {
    const thisMoment = moment()
    this.setState((prevState) =>
      ({
        elapsed: {
          hours: thisMoment.diff(prevState.startTime, 'hours'),
          minutes: thisMoment.diff(prevState.startTime, 'minutes'),
          seconds: thisMoment.diff(prevState.startTime, 'seconds')
        }
      })
    )
  }

  initWorkData(result) {
    this.setState((prevState) => {
      this.startTimer()
      return {
        // currentTaskState: this.TASK_STATES.STARTED,
        workData: result.data,
        startTime: prevState.startTime !== null ? prevState.startTime : moment(),
        errMsg: ''
      }
    }, () => {
      // setTimeout(() => {
      //   this.goBackToScanEmployee()
      // }, 5000)

    })

    // if (this.state.currentTaskState === this.TASK_STATES.NONE) {
    //   this.setState({
    //     // currentTaskState: this.TASK_STATES.STARTED,
    //     workData: result.data,
    //     startTime: moment(),
    //     errMsg: ''
    //   }, () => {
    //     this.startTimer()
    //   })
    // }
    // else if (this.state.currentTaskState === this.TASK_STATES.STARTED) {
    //   // display QR, scan it to pause this task
    //   this.setState({ currentTaskState: this.TASK_STATES.DISPLAY_SCAN_TO_PAUSE })
    // }
  }

  onEmployeeUrlChange(e) {
    this.setState({ employeeUrl: e.target.value })
  }

  handleEmployeeURL(params) {
    const ex_emp_id = params['e_id']
    const bf_org_id = params['o_id']
    QRstore.loadEmployee(ex_emp_id, bf_org_id,
      (result) => {
        console.log(result)
        const url = 'http://localhost:3000/?p=tcp&w_id=17221edb-f&o_id=korat'
        this.setState({
          profileImgURL: QRstore.getProfileImgURL(ex_emp_id, bf_org_id),
          employeeData: result.data,
          employeeUrl: url,
          errMsg: ''
        }, () => {

        })
      },
      (err) => { })
  }

  onEmployeeUrlKeyPress(e) {
    if (e.key !== 'Enter' || this.state.employeeUrl === '') return
    // submit employee url to backend

    const url = e.target.value
    const qStr = url.slice(url.indexOf('?') + 1)
    const params = querystring.parse(qStr)
    const page = params['p']
    const { profileImgURL } = this.state
    if (page === 'tr') {
      // this.setState({ errMsg: 'สแกนบัตรพนักงานก่อน' })
      this.handleEmployeeURL(params)
      return
    } else if (profileImgURL !== '' && page === 'tcp') {
      this.handleWorkUrl(params)
      return
    } else if (profileImgURL === '' && page === 'tcp') {
      this.setState({ errMsg: 'สแกนบัตรพนักงานก่อน' })
      return
    }
    /* const ex_emp_id = params['e_id']
    const bf_org_id = params['o_id']
    QRstore.loadEmployee(ex_emp_id, bf_org_id,
      (result) => {
        console.log(result)
        const url = 'http://localhost:3000/?p=tcp&w_id=17221edb-f&o_id=korat'
        this.setState({
          profileImgURL: QRstore.getProfileImgURL(ex_emp_id, bf_org_id),
          employeeData: result.data,
          workUrl: url,
          errMsg: ''
        }, () => {

        })
      },
      (err) => { }) */
  }

  onWorkUrlChange(e) {
    this.setState({ workUrl: e.target.value })
  }

  handleWorkUrl(params) {
    const ex_work_id = params['w_id']
    const bf_org_id = params['o_id']
    const ex_emp_id = this.state.employeeData.ext_employee_id
    /* 
    // in case check emp_id on front-end
    // const ex_emp_id = params['e_id']
    if (this.state.employeeData.ext_employee_id !== ex_emp_id) {
      // err msg: incorrect emp id
      return
    } */

    QRstore.loadCar(ex_work_id, bf_org_id, ex_emp_id,
      (result) => {
        console.log(result)
        // check if task state is either NONE, STARTED,...
        // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE
        this.initWorkData(result)
      },
      (err) => {
        // incorrect emp_id
      })
  }

  onWorkUrlKeyPress(e) {
    // on scan work url
    if (
      e.key !== 'Enter'
      || this.state.workUrl === ''
      || Object.keys(this.state.employeeData).length === 0
    ) return
    // submit employee url to backend

    const url = e.target.value
    const qStr = url.slice(url.indexOf('?') + 1)
    const params = querystring.parse(qStr)
    const page = params['p']
    if (page !== 'tcp') {
      this.setState({ errMsg: 'สแกนใบงานเท่านั้น' })
      return
    }

    // const ex_work_id = params['w_id']
    // const bf_org_id = params['o_id']
    // const ex_emp_id = this.state.employeeData.ext_employee_id
    // /* 
    // // in case check emp_id on front-end
    // // const ex_emp_id = params['e_id']
    // if (this.state.employeeData.ext_employee_id !== ex_emp_id) {
    //   // err msg: incorrect emp id
    //   return
    // } */

    // QRstore.loadCar(ex_work_id, bf_org_id, ex_emp_id,
    //   (result) => {
    //     console.log(result)
    //     // check if task state is either NONE, STARTED,...
    //     // result.data.task.tasklist[0].startDate === '' --> state.currentTaskState === this.TASK_STATES.NONE
    //     this.initWorkData(result)
    //   },
    //   (err) => {
    //     // incorrect emp_id
    //   })
  }

  renderCounter(hours, minutes, seconds) {
    const theHours = hours
    const theMinutes = minutes - hours * 60
    const theSeconds = seconds - minutes * 60
    const displayHours = theHours > 0 ? `${theHours} ชั่วโมง` : ''
    const displayMinutes = theMinutes > 0 ? `${theMinutes} นาที` : ''
    const displaySeconds = `${theSeconds} วินาที`
    const time = `${displayHours} ${displayMinutes} ${displaySeconds}`
    // const displayTime = isNaN(time) ? '' : time
    // console.log(displayTime)
    return `เริ่มงานไปแล้ว ${displayHours} ${displayMinutes} ${displaySeconds}`
  }

  renderScanTaskOptions() {
    const scanComps = [
      this.renderScanToPause(),
      this.renderScanToStop()
    ].map((ele, idx) => (
      <Col key={idx} md={6}>{ele}</Col>
    ))
    return (
      <Row>{scanComps}</Row>
    )
  }

  renderTaskPauseStop() {
    const { workData, startTime, elapsed } = this.state
    const taskLabel = 'ประเภทงาน'
    // const startTime = moment('05:06:07')
    // const diff = moment.duration(startTime).asSeconds()

    const displayStartDateTime =
      `เริ่มงาน ${moment(startTime).format('DD/MM/YYYY')}
          เวลา ${moment(startTime).format("HH:mm")}`
    const counter = this.renderCounter(elapsed['hours'], elapsed['minutes'], elapsed['seconds'])
    const lst = [workData.car_registration_no, taskLabel, displayStartDateTime, counter]
    const carInfo = lst.map((ele, idx, arr) => {
      return (
        <h1 key={idx}>{ele}</h1>
      )
    })

    // carInfo.concat()
    const qr4Task = this.renderScanTaskOptions()
    return (
      <div>
        {qr4Task}
        {carInfo}
      </div>
    )
  }

  renderTaskStart() {
    const { workData, startTime, elapsed } = this.state
    const taskLabel = 'ประเภทงาน'
    // const startTime = moment('05:06:07')
    // const diff = moment.duration(startTime).asSeconds()

    const displayStartDateTime =
      `เริ่มงาน ${moment(startTime).format('DD/MM/YYYY')}
          เวลา ${moment(startTime).format("HH:mm")}`
    const startCheck = (
      <FontAwesome
        // className="super-crazy-colors"
        name="check"
        // size="1x"
        // spin
        style={{
          textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)',
          color: 'green'
        }}
      />
    )
    const counter = this.renderCounter(elapsed['hours'], elapsed['minutes'], elapsed['seconds'])
    const displayCounter = (
      <div>{startCheck}{counter}</div>
    )
    const lst = [workData.car_registration_no, taskLabel, displayStartDateTime, displayCounter]
    const lis = lst.map((ele, idx, arr) => {
      return (
        <li key={idx}><h1>{ele}</h1></li>
      )
    })
    return (
      <ul>
        {lis}
      </ul>
    )
  }

  onScanToPauseChange(e) {

  }

  onScanToPauseKeyPress(e) {
    this.setState({ qrPauseBgColor: this.QR_BG_COLOR.SCANNING }, () => {
      clearInterval(this.timer)
      setTimeout(() => {
        this.setState({ qrPauseBgColor: this.QR_BG_COLOR.DEFAULT })
      }, 300)
    })

    // setTimeout(() => {
    //   this.setState({ qrBgColor: this.QR_BG_COLOR.SCANNING })
    // }, 1000)

  }

  onScanToStopKeyPress(e) {
    this.setState({ qrStopBgColor: this.QR_BG_COLOR.SCANNING }, () => {
      clearInterval(this.timer)
      setTimeout(() => {
        this.setState({ qrStopBgColor: this.QR_BG_COLOR.DEFAULT })
      }, 300)
    })
  }

  renderScanToStop() {
    if (this.state.startTime === null) return null
    return (
      <div>
        <FormControl
          autoFocus
          type='text'
          // placeholder='ใส่ URL สำหรับสแกนพนักงาน'
          value={this.state.workUrl}
          onChange={this.onScanToPauseChange.bind(this)}
          onKeyPress={this.onScanToStopKeyPress.bind(this)}
        />
        <QRCode
          bgColor={this.state.qrStopBgColor}
          fgColor="#000000"
          level="Q"
          style={{
            width: 128,
            borderStyle: 'solid',
            borderColor: 'green'
          }}
          value={this.state.workUrl}
        />
      </div>
    )
  }

  renderScanToPause() {
    if (this.state.startTime === null) return null
    return (
      <div>
        <FormControl
          autoFocus
          type='text'
          // placeholder='ใส่ URL สำหรับสแกนพนักงาน'
          value={this.state.workUrl}
          onChange={this.onScanToPauseChange.bind(this)}
          onKeyPress={this.onScanToPauseKeyPress.bind(this)}
        />
        <QRCode
          bgColor={this.state.qrPauseBgColor}
          fgColor="#000000"
          level="Q"
          style={{
            width: 128,
            borderStyle: 'solid',
            borderColor: 'yellow'
          }}
          value={this.state.workUrl}
        />
      </div>
    )
  }

  renderTask() {
    // const { workData, startTime, elapsed } = this.state
    const { workData } = this.state
    if (Object.keys(workData).length === 0) return null
    if (this.state.currentTaskState === this.TASK_STATES.STARTED) {
      return this.renderTaskPauseStop()
    }
    return this.renderTaskStart()

    // if (this.state.currentTaskState === this.TASK_STATES.STARTED) {
    //   return this.renderTaskStart()
    // }
    // else if (this.state.currentTaskState === this.TASK_STATES.DISPLAY_SCAN_TO_PAUSE) {
    //   return this.renderScanToPause()
    // }
    // return null
  }

  renderProfile() {
    const { profileImgURL, employeeData, errMsg } = this.state
    if (profileImgURL === '')
      return null

    const lis = [
      `${employeeData.first_name} ${employeeData.last_name}`,
      employeeData.position
    ].map((ele, index) =>
      <li key={index}><h1>{ele}</h1></li>
    )
    return (
      <div>
        <Image src={profileImgURL} circle />
        <ul>
          {lis}
        </ul>
        {this.renderTask()}
      </div>
    )
  }

  renderWorkUrlInput() {
    if (this.state.profileImgURL === '') return null

    return (
      <FormControl
        autoFocus
        type='text'
        // placeholder='ใส่ URL สำหรับสแกนพนักงาน'
        value={this.state.workUrl}
        onChange={this.onWorkUrlChange.bind(this)}
        onKeyPress={this.onWorkUrlKeyPress.bind(this)}
      />
    )
  }

  renderEmployeeUrlInput() {
    // if (this.state.profileImgURL !== '') return null
    return (
      <FormControl
        autoFocus
        type='text'
        // placeholder='ใส่ URL สำหรับสแกนพนักงาน'
        value={this.state.employeeUrl}
        onChange={this.onEmployeeUrlChange.bind(this)}
        onKeyPress={this.onEmployeeUrlKeyPress.bind(this)}
      />
    )
  }

  renderErrorMsg() {
    return (
      <h1 style={{ color: 'red' }}>{this.state.errMsg}</h1>
    )
  }

  goBackToScanEmployee() {
    this.setState({
      currentTaskState: this.TASK_STATES.STARTED,
      employeeUrl: this.EMPLOYEE_URL,
      workUrl: '',
      profileImgURL: '',
      employeeData: {},
      workData: {},
      // startTime: null,
      elapsed: {},
      errMsg: '',
      qrBgColor: this.QR_BG_COLOR.DEFAULT
    })
  }

  onBackHomeButtonClick(e) {
    this.goBackToScanEmployee()
  }

  renderStateButtons() {
    return (
      <Button
        onClick={this.onBackHomeButtonClick.bind(this)}
      >
        กลับสู่หน้าสแกนเพื่อหยุดงานชั่วคราว
      </Button>
    )
  }

  render() {
    const mainStyle = {
      width: 800,
      margin: '15px auto 10px',
      textAlign: 'center'
    }

    return (
      <Box>
        <Box.Header>
        </Box.Header>
        <Box.Body>
          <Grid>
            <Row>
              <div style={mainStyle}>
                {this.renderStateButtons()}
                {this.renderEmployeeUrlInput()}
                {this.renderProfile()}
                {this.state.errMsg !== '' && this.renderErrorMsg()}
              </div>
            </Row>
          </Grid>

        </Box.Body>
      </Box>
    )
  }
}

export default Tracker


// WEBPACK FOOTER //
// ./src/view/workdoc/qrtracker/Tracker.js